import DriversFilter from "../../driverComponent/allDrivers/driversFilter/driversFilter";
import Pagination from "../../../shared/pagination/pagination";
import VehicleList from "./vehicleList/vehicleList";

const AllVehicles = () => {
    return(
        <div className={'driver-section flex gap-0 align-top hr-space-between'}>
            <div className="page-filter-sec">
                <DriversFilter/>
            </div>
            <div className={'driver-table'}>
                <div className="margin-b-30">
                    <div className="search-box drivers-search width-block-100 margin-b-30 round-corner-8">
                        <input type="text" placeholder={'Search'}/>
                    </div>
                    <div className="sf-medium font-18">List View</div>
                </div>
                <div className="margin-b-50"><VehicleList/></div>
                <div className=""><Pagination/></div>

            </div>
        </div>
    )
}

export default AllVehicles;
